
const mixin = {
    data: ()=>{
        return {
            ui:{
                loading: [],
                isLoading(item){
                    if(item)
                        return (this.loading.indexOf(item) != -1)
                    else
                        return this.loading.length
                },
                stopLoading(item){
                    var idx
                    if(item){
                        if((idx = this.loading.indexOf(item)) != -1)
                            this.loading.splice(idx, 1)
                    }else{
                        this.loading = []
                    }
                }
            }
        }
    },
    methods:{
        messageBox(message, title, options)
        {
            //return MessageBox.confirm(message, title, options)
        },
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/ui.js